import { PublicNav } from "@/components/layout/PublicNav";
import { Footer } from "@/components/layout/Footer";

export function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicNav />
      <main className="flex-1 pdg-fade-in">{children}</main>
      <Footer />
    </div>
  );
}
